import moment from "moment";
import {
    INICIA_DIARIO,
    INICIO_DIARIO_SUCESSO,
    BUSCA_DIARIO,
    BUSCA_DIARIO_SUCESSO,
    LISTA_CURSOS_DIARIO,
    LISTA_CURSOS_DIARIO_SUCESSO,
    LISTA_SERIES_DIARIO,
    LISTA_SERIES_DIARIO_SUCESSO,
    LISTA_TURMAS_DIARIO,
    LISTA_TURMAS_DIARIO_SUCESSO,
    LANCA_FALTAS_DIARIO,
    LANCA_FALTAS_DIARIO_SUCESSO,
    LIMPAR_DIARIO,
    VOLTAR_PARA_FILTROS_DIARIO,
    TOGGLE_FALTA_DIARIO,
    HIDE_MESSAGE,
    ON_HIDE_LOADER,
    ON_SHOW_LOADER,
    ON_SHOW_SUCCESS_MESSAGE,
    ON_SHOW_ERROR_MESSAGE,
    SHOW_MESSAGE,
    ALTERACAO_CAMPO,
    ALTERACAO_COMBO,
    ALTERACAO_DATEPICKER,
    REABRIR_DIARIO,
    REABRIR_DIARIO_SUCESSO,
    FECHAR_DIARIO,
    FECHAR_DIARIO_SUCESSO
} from "constants/ActionTypes";

const INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessageSuccess: false,
    showMessageError: false,

    // Filtros
    anoLetivo: '',
    escolaId: null,
    cursoId: null,
    serieId: null,
    turmaId: null,
    data: moment().format('DD/MM/YYYY'),

    // Listas
    listaEscolas: [],
    listaCursos: [],
    listaSeries: [],
    listaTurmas: [],

    // Flags de carregamento
    cursosCarregados: false,
    seriesCarregadas: false,
    turmasCarregadas: false,

    // Resultado
    buscando: false,
    exibirDiario: false,
    diario: null // Estrutura: { idTurma, nomeTurma, data, disciplinas: [], alunos: [] }
};

const normalizeItem = (item, idKey = 'id', titleKey = 'nome') => {
    const id = item[idKey] || item.Id || item.idItemMenu || item.cursoId || item.CursoId || item.serieId || item.SerieId || item.etapaId || item.EtapaId || item.value;
    const title = item[titleKey] || item.Nome || item.descricao || item.Descricao || item.cursoNome || item.title || String(id || '');
    return { id, title };
};

const normalizeDiarioData = (data) => {
    if (!data) return null;
    return {
        ...data,
        disciplinas: (data.disciplinas || []).map(d => ({
            ...d,
            componenteEscolaId: d.componenteEscolaId || d.id || d.Id || d.componenteCurricularId || d.disciplinaId,
            nome: d.nome || d.nomeDisciplina || d.disciplinaNome || d.descricao
        })),
        alunos: (data.alunos || []).map(a => ({
            ...a,
            matriculaId: a.matriculaId || a.id || a.Id || a.MatriculaId,
            nomeAluno: a.nomeAluno || a.alunoNome || a.Nome || '',
            faltas: (a.faltas || []).map(f => ({
                ...f,
                componenteEscolaId: f.componenteEscolaId || f.id || f.Id || f.componenteCurricularId || f.disciplinaId
            }))
        }))
    };
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case INICIA_DIARIO:
            return {
                ...state,
                loader: true,
                exibirDiario: false,
                diario: null,
                anoLetivo: '',
                escolaId: null,
                cursoId: null,
                serieId: null,
                turmaId: null,
                data: moment().format('DD/MM/YYYY'),
                listaCursos: [],
                listaSeries: [],
                listaTurmas: [],
                cursosCarregados: false,
                seriesCarregadas: false,
                turmasCarregadas: false
            };
        case INICIO_DIARIO_SUCESSO:
            return {
                ...state,
                loader: false,
                listaEscolas: (action.payload.escolas || []).map(e => normalizeItem(e))
            };
        case BUSCA_DIARIO:
            return { ...state, buscando: true, loader: true };
        case BUSCA_DIARIO_SUCESSO: {
            const dataBusca = action.payload;
            return {
                ...state,
                buscando: false,
                loader: false,
                exibirDiario: true,
                diario: normalizeDiarioData(dataBusca),
                turmaId: dataBusca.idTurma || state.turmaId,
                data: dataBusca.data ? moment(dataBusca.data).format('DD/MM/YYYY') : state.data,
                anoLetivo: dataBusca.anoLetivo || (dataBusca.data ? moment(dataBusca.data).format('YYYY') : state.anoLetivo)
            };
        }
        case LISTA_CURSOS_DIARIO:
            return { ...state, listaCursos: [], cursosCarregados: false, seriesCarregadas: false, turmasCarregadas: false };
        case LISTA_CURSOS_DIARIO_SUCESSO:
            return {
                ...state,
                listaCursos: (action.payload || []).map(c => normalizeItem(c, 'id', 'cursoNome')),
                cursosCarregados: true
            };
        case LISTA_SERIES_DIARIO:
            return { ...state, listaSeries: [], seriesCarregadas: false, turmasCarregadas: false };
        case LISTA_SERIES_DIARIO_SUCESSO:
            return {
                ...state,
                listaSeries: (action.payload || []).map(s => normalizeItem(s)),
                seriesCarregadas: true
            };
        case LISTA_TURMAS_DIARIO:
            return { ...state, listaTurmas: [], turmasCarregadas: false };
        case LISTA_TURMAS_DIARIO_SUCESSO:
            return {
                ...state,
                listaTurmas: (action.payload || []).map(t => normalizeItem(t)),
                turmasCarregadas: true
            };
        case TOGGLE_FALTA_DIARIO: {
            const { matriculaId, componenteEscolaId, faltou } = action.payload;
            if (!state.diario) return state;

            const novosAlunos = (state.diario.alunos || []).map(aluno => {
                if (aluno.matriculaId === matriculaId) {
                    const faltasPuras = aluno.faltas || [];
                    const index = faltasPuras.findIndex(f => f.componenteEscolaId === componenteEscolaId);

                    let novasFaltas;
                    if (index >= 0) {
                        novasFaltas = [...faltasPuras];
                        novasFaltas[index] = { ...novasFaltas[index], faltou };
                    } else {
                        novasFaltas = [...faltasPuras, { componenteEscolaId, faltou }];
                    }
                    return { ...aluno, faltas: novasFaltas };
                }
                return aluno;
            });

            return {
                ...state,
                diario: { ...state.diario, alunos: novosAlunos }
            };
        }
        case LANCA_FALTAS_DIARIO_SUCESSO: {
            const dataPayload = action.payload;
            return {
                ...state,
                diario: normalizeDiarioData(dataPayload),
                turmaId: dataPayload.idTurma || state.turmaId,
                data: dataPayload.data ? moment(dataPayload.data).format('DD/MM/YYYY') : state.data,
                anoLetivo: dataPayload.anoLetivo || (dataPayload.data ? moment(dataPayload.data).format('YYYY') : state.anoLetivo)
            };
        }
        case LIMPAR_DIARIO:
            return { ...INIT_STATE, listaEscolas: state.listaEscolas };
        case VOLTAR_PARA_FILTROS_DIARIO:
            return { ...state, exibirDiario: false, diario: null };
        case REABRIR_DIARIO:
        case FECHAR_DIARIO:
            return { ...state, loader: true };
        case REABRIR_DIARIO_SUCESSO:
        case FECHAR_DIARIO_SUCESSO:
            return { ...state, loader: false };
        case ALTERACAO_CAMPO:
            return { ...state, [action.payload.target.name]: action.payload.target.value };
        case ALTERACAO_COMBO: {
            const { nomeCombo, valor } = action.payload;
            return { ...state, [nomeCombo[0]]: valor };
        }
        case ALTERACAO_DATEPICKER:
            return { ...state, [action.payload.name]: action.payload.date };
        case HIDE_MESSAGE:
            return { ...state, alertMessage: '', showMessageSuccess: false, showMessageError: false, loader: false };
        case ON_SHOW_ERROR_MESSAGE:
        case SHOW_MESSAGE:
            return { ...state, buscando: false, loader: false, alertMessage: action.payload, showMessageError: true };
        case ON_SHOW_SUCCESS_MESSAGE:
            return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true };
        case ON_SHOW_LOADER:
            return { ...state, loader: true };
        case ON_HIDE_LOADER:
            return { ...state, loader: false };
        default:
            return state;
    }
};
